import dayjs from 'dayjs'

export const adjustTime = (time) => {

  return dayjs
    .unix(time)
    .utc()
    .locale('nl')
    .format('YYYY-MM-DD HH:mm:ss')
}